import { render } from "./PotList.vue?vue&type=template&id=9753fc26&ts=true"
import script from "./PotList.vue?vue&type=script&lang=ts"
export * from "./PotList.vue?vue&type=script&lang=ts"

import "./PotList.vue?vue&type=style&index=0&id=9753fc26&lang=css"

import exportComponent from "D:\\a\\1\\s\\src\\BespokeRetirements.UI.Web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__